import Cookies from "js-cookie";

// Utility function to get cookie data as an array
export const getCookieArray = (key: string) => {
  const cookieValue = Cookies.get(key);
  return cookieValue ? JSON.parse(cookieValue) : [];
};

// Add or remove a post ID from a cookie-based array
export const toggleCookieItem = (key: string, postId: number) => {
  const items = getCookieArray(key);
  const updatedItems = items.includes(postId)
    ? items.filter((id: number) => id !== postId) // Remove if exists
    : [...items, postId]; // Add if doesn't exist
  Cookies.set(key, JSON.stringify(updatedItems), { expires: 7 }); // Expires in 7 days
  return updatedItems.includes(postId);
};

// Check if a post ID exists in the cookie
export const isInCookie = (key: string, postId: number) => {
  const items = getCookieArray(key);
  return items.includes(postId);
};
